import { Component, Input, OnInit } from '@angular/core';
import { SelectItem } from 'primeng/api';

@Component({
    selector: 'ef-dropdown',
    templateUrl: './ef-dropdown.component.html',
    styleUrls: ['./ef-dropdown.component.scss'],
    standalone: false
})
export class EfDropdownComponent implements OnInit {
    @Input() items: SelectItem[];
    @Input() rowData: any;
    @Input() property: any;
    @Input() disabled: boolean;
    constructor() {}

    ngOnInit(): void {
        // this.log.verbose("ef-dropdown ngModel: " + this.rowData[this.property]);
    }
}
